<template>
  <!-- Ce qu'il faut savoir avant de poser, du plus urgent au plus anodin. Rien à dire : rien d'affiché. -->
  <div v-if="hasSomething" class="field-briefing">
    <v-alert v-if="order.fieldIssue" type="error" text dense class="text-body-2 mb-3">
      <div class="font-weight-medium">{{ $t('onboarding.field.briefing.previous-issue', { reason: issueReasonLabel(order.fieldIssue.reason), date: $options.filters.formatDate(order.fieldIssue.at) }) }}</div>
      <div v-if="order.fieldIssue.note">« {{ order.fieldIssue.note }} »</div>
    </v-alert>

    <v-alert v-if="order.installationNotes" type="info" text dense icon="mdi-clipboard-text-outline" class="text-body-2 mb-3">
      <div class="font-weight-medium">{{ $t('onboarding.field.briefing.notes') }}</div>
      <div class="field-briefing__notes">{{ order.installationNotes }}</div>
    </v-alert>

    <v-alert v-if="restrictionsOf(order)" type="warning" text dense class="text-body-2 mb-3">
      {{ $t('onboarding.commissioning.field-restrictions', { restrictions: restrictionsOf(order) }) }}
    </v-alert>

    <v-card v-if="hasFacts" outlined>
      <v-list dense class="py-0">
        <v-list-item v-if="order.profile && order.profile.name">
          <v-list-item-icon class="mr-3"><v-icon>{{ kindIcon(order.kind) }}</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('onboarding.commissioning.profile') }}</v-list-item-subtitle>
            <v-list-item-title class="text-wrap">{{ order.profile.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="order.equipmentLabel">
          <v-list-item-icon class="mr-3"><v-icon>mdi-package-variant-closed</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('onboarding.field.briefing.prepared') }}</v-list-item-subtitle>
            <v-list-item-title class="text-wrap">{{ order.equipmentLabel }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="order.survey">
          <v-list-item-icon class="mr-3"><v-icon>mdi-clipboard-check-outline</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>
              {{ $t('onboarding.commissioning.survey.title') }} · {{ $t(`onboarding.commissioning.survey.mode.${order.survey.mode}`) }}<span v-if="order.survey.scheduledAt"> · {{ order.survey.scheduledAt | formatDate('DD/MM/YY') }}</span>
            </v-list-item-subtitle>
            <v-list-item-title class="text-wrap">
              {{ order.survey.outcome ? $t(`onboarding.commissioning.survey.outcome.${order.survey.outcome}`) : $t('onboarding.field.briefing.survey-pending') }}
            </v-list-item-title>
            <div v-if="order.survey.notes" class="text-body-2 mt-1 field-briefing__notes">{{ order.survey.notes }}</div>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="reference">
          <v-list-item-icon class="mr-3"><v-icon>mdi-pound</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('onboarding.field.briefing.reference') }}</v-list-item-subtitle>
            <v-list-item-title class="text-wrap">{{ reference }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import CommissioningMixin from '../CommissioningMixin'
import FieldMixin from './FieldMixin'

/**
 * Le brief de pose : le problème du dernier passage, les consignes du bureau, les restrictions de
 * matériel, puis le profil, l'équipement préparé, la visite technique et la référence.
 */
export default {
  name: 'FieldBriefing',

  mixins: [CommissioningMixin, FieldMixin],

  props: {
    order: { type: Object, required: true },
  },

  computed: {
    hasFacts() {
      const o = this.order
      return !!(o.profile?.name || o.equipmentLabel || o.survey || this.reference)
    },

    /** La référence métier (n° de dossier, de commande client) ; jamais un lien interne (inscription, commande, montée). */
    reference() {
      const ref = this.order.originReference
      return ref && !/^(registration|equipment-order|upgrade-of):/.test(ref) ? ref : null
    },

    hasSomething() {
      return this.hasFacts || !!(this.order.fieldIssue || this.order.installationNotes || this.restrictionsOf(this.order))
    },
  },
}
</script>

<style scoped>
.field-briefing__notes {
  white-space: pre-line;
}
</style>
